export default __webpack_public_path__ + "5a908ad75d812721e24e25b7eff27beb.svg";